import Grid2 from "@mui/material/Grid2";
import {
  Inventory2Outlined,
  GroupsOutlined,
  SellOutlined,
  BarChartOutlined,
  ReceiptLongOutlined,
  AssessmentOutlined,
  PaidOutlined,
} from "@mui/icons-material";
import { KPISummaryCard } from "./KPISummaryCard";
import { Box } from "@mui/material";
import { formatCurrency } from "../../../utils";
import { KPIReportResponse } from "../../../types";

export const KPISummaryRow = ({
  data,
  loading,
}: {
  data?: KPIReportResponse;
  loading?: boolean;
}) => {
  const summaryItems = [
    {
      title: "No: of Customers",
      value: (data?.numberOfAccounts || 0).toLocaleString(),
      icon: <GroupsOutlined sx={{ color: "#2563FF", fontSize: 30 }} />,
      iconBg: "#EAF1FF",
    },

    {
      title: "Wash Count",
      value: (data?.numberOfWashes || 0).toLocaleString(),
      icon: <Inventory2Outlined sx={{ color: "#1F8F2F", fontSize: 30 }} />,
      iconBg: "#EDF7EE",
    },

    {
      title: "Average Wash Rate",
      value: formatCurrency(data?.averagePricePerWash || 0),
      icon: <SellOutlined sx={{ color: "#7C3AED", fontSize: 30 }} />,
      iconBg: "#F3E8FF",
    },

    {
      title: "Average Revenue Per Customer",
      value: formatCurrency(data?.averageRevenuePerAccount || 0),
      subtitle: `No. of Invoices: ${(data?.numberOfInvoices || 0).toLocaleString()}`,
      icon: <ReceiptLongOutlined sx={{ color: "#EA7A00", fontSize: 30 }} />,
      iconBg: "#FFF4E8",
    },

    {
      title: "Average Units Per Customer",
      value: (data?.averageWashesPerAccount || 0).toLocaleString(),
      icon: <AssessmentOutlined sx={{ color: "#0891B2", fontSize: 30 }} />,
      iconBg: "#EAF8FC",
    },

    {
      title: "Gross Revenue",
      value: formatCurrency(data?.grossRevenue || 0),
      icon: <BarChartOutlined sx={{ color: "#2563FF", fontSize: 30 }} />,
      iconBg: "#EEF4FF",
    },
    {
      title: "Payments Received",
      value: formatCurrency(data?.paymentsReceived || 0),
      subtitle: `No. of Invoices: ${(data?.numberOfPaidInvoices || 0).toLocaleString()}`,
      icon: <PaidOutlined sx={{ color: "#16A34A", fontSize: 30 }} />,
      iconBg: "#ECFDF3",
    },

    {
      title: "Past Due Invoices",
      value: formatCurrency(data?.outstandingBalance || 0),
      subtitle: `No. of Invoices: ${(data?.numberOfUnpaidInvoices || 0).toLocaleString()}`,
      icon: <PaidOutlined sx={{ color: "#DC2626", fontSize: 30 }} />,
      iconBg: "#FEF2F2",
    },
  ];
  return (
    <Box sx={{ position: "relative" }}>
      <Grid2 container spacing={2}>
        {summaryItems.map((item) => (
          <Grid2 key={item.title} size={{ xs: 12, sm: 6, md: 3 }}>
            <KPISummaryCard
              title={item.title}
              value={item.value}
              subtitle={item.subtitle}
              icon={item.icon}
              iconBg={item.iconBg}
              loading={loading}
            />
          </Grid2>
        ))}
      </Grid2>
    </Box>
  );
};
